import { useCallback, useEffect, useState } from 'react';

export const useChecklistViewState = () => {
    const [isOpenChecklist, setIsOpenChecklist] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false);

    const handleClick = useCallback(() => {
        setIsOpenChecklist((prevIsOpenChecklist) => {
            if (isEditMode) {
                return prevIsOpenChecklist;
            }

            return !prevIsOpenChecklist;
        });
    }, [isEditMode]);

    const markCopied = useCallback(() => {
        setIsCopied(true);
    }, []);

    const openDeletePopup = useCallback(() => {
        setIsOpenDeletePopup(true);
    }, []);

    const closeDeletePopup = useCallback(() => {
        setIsOpenDeletePopup(false);
    }, []);

    const openChecklist = useCallback(() => {
        setIsOpenChecklist(true);
    }, []);

    const closeChecklist = useCallback(() => {
        setIsOpenChecklist(false);
    }, []);

    const enableEditMode = useCallback(() => {
        setIsEditMode(true);
    }, []);

    const disableEditMode = useCallback(() => {
        setIsEditMode(false);
    }, []);

    const resetAfterDelete = useCallback(() => {
        setIsOpenDeletePopup(false);
        setIsEditMode(false);
        setIsOpenChecklist(false);
    }, []);

    useEffect(() => {
        if (!isCopied) {
            return undefined;
        }

        const timeoutId = window.setTimeout(() => {
            setIsCopied(false);
        }, 3000);

        return () => window.clearTimeout(timeoutId);
    }, [isCopied]);

    return {
        isOpenChecklist,
        isCopied,
        isEditMode,
        isOpenDeletePopup,
        handleClick,
        markCopied,
        openDeletePopup,
        closeDeletePopup,
        openChecklist,
        closeChecklist,
        enableEditMode,
        disableEditMode,
        resetAfterDelete,
    };
};
